import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import { EngineeringHttpService } from '@core/services/http';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';
import { EngineeringActions } from '@store/actions';
import store from '@store/index';

export class EngineeringDetailsResolver implements Resolver {
  async resolve(): Promise<void> {
    const [projectBundleID] = getProjectBundleIDParamFromUrl();

    store.dispatch(EngineeringActions.resetTabsData.done(undefined));

    await HttpService.getHttpRequests(
      EngineeringHttpService,
    ).getEngineeringSummary(projectBundleID);
  }
}
